.lead-fit-card {
    border-radius: 8px;
    padding: 12px 16px;
}

.lead-fit-card--ideal {
    background: var(--success-bg);
}

.lead-fit-card--possible {
    background: color-mix(in srgb, var(--warning-bg) 80%, transparent);
}

.lead-fit-card--unlikely {
    background: color-mix(in srgb, var(--red-lt) 60%, transparent);
}

.lead-fit-card--unknown {
    background: var(--off-white);
}

.lead-fit-label {
    font-size: var(--font-small);
    color: var(--grey);
}

.lead-fit-value {
    font-size: var(--font-big);
    font-weight: 500;
}

.lead-fit-value--ideal {
    color: var(--success);
}

.lead-fit-value--possible {
    color: var(--warning);
}

.lead-fit-value--unlikely {
    color: var(--red);
}

.lead-fit-value--unknown {
    color: var(--grey);
}

.gauge-container {
    height: 40px;
}

.lead-fit-reasons {
    list-style: none;
    margin: 0;
    padding: 0;
}
